import { Avatar as AvatarPrimitive } from "radix-ui";
import { cn } from "@/lib/utils.ts";

function initials(name: string | null, email: string): string {
  const source = (name ?? "").trim() || email;
  const parts = source.split(/[\s@._-]+/).filter(Boolean);
  const letters = parts.length >= 2 ? `${parts[0]?.[0] ?? ""}${parts[1]?.[0] ?? ""}` : source.slice(0, 2);
  return letters.toLocaleUpperCase();
}

export function Avatar({
  name,
  email,
  src,
  className,
}: {
  name: string | null;
  email: string;
  src: string | null;
  className?: string;
}) {
  return (
    <AvatarPrimitive.Root className={cn("relative flex size-8 shrink-0 overflow-hidden rounded-full", className)}>
      {src ? <AvatarPrimitive.Image src={src} alt="" className="aspect-square size-full object-cover" /> : null}
      <AvatarPrimitive.Fallback
        delayMs={src ? 400 : 0}
        className="flex size-full items-center justify-center bg-primary text-[11px] font-bold text-primary-foreground"
      >
        {initials(name, email)}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
}
